import React, { RefObject } from 'react';

interface DetailedSectionsProps {
  hftRef: RefObject<HTMLDivElement>;
  mlRef: RefObject<HTMLDivElement>;
  caRef: RefObject<HTMLDivElement>;
}

const DetailedSections: React.FC<DetailedSectionsProps> = ({ hftRef, mlRef, caRef }) => (
  <section className="w-full py-12 md:py-24 lg:py-32">
    <div className="container px-4 md:px-6">
      <div className="space-y-10">
        {/* High-Frequency Trading Detail */}
        <div ref={hftRef} className="space-y-4">
          <h2 className="text-3xl font-bold tracking-tighter md:text-4xl/tight">High-Frequency Trading</h2>
          <p className="text-muted-foreground md:text-xl">
            Our high-frequency trading systems leverage cutting-edge technology to execute trades at unprecedented speeds. 
            By analyzing market data in microseconds, we can identify and capitalize on fleeting opportunities, providing 
            liquidity and narrowing spreads across various markets. Our HFT strategies are designed to manage risk effectively 
            while maximizing returns, even in the most volatile market conditions.
          </p>
        </div>

        {/* Machine Learning Models Detail */}
        <div ref={mlRef} className="space-y-4">
          <h2 className="text-3xl font-bold tracking-tighter md:text-4xl/tight">Machine Learning Models</h2>
          <p className="text-muted-foreground md:text-xl">
            At FF Automaton, we harness the power of advanced machine learning algorithms to predict market movements and 
            optimize trading strategies. Our models are trained on vast amounts of historical and real-time data, enabling 
            them to identify complex patterns and correlations that human traders might miss. These AI-driven systems 
            continuously adapt to changing market conditions, ensuring that our strategies remain effective in diverse 
            trading environments.
          </p>
        </div>

        {/* Custom Algorithms Detail */}
        <div ref={caRef} className="space-y-4">
          <h2 className="text-3xl font-bold tracking-tighter md:text-4xl/tight">Custom Algorithms</h2>
          <p className="text-muted-foreground md:text-xl">
            We understand that every trader and institution has unique needs and risk profiles. That's why we offer 
            custom algorithm development services. Our team of experienced quants and developers work closely with 
            clients to design, implement, and optimize trading algorithms tailored to specific strategies, asset classes, 
            or market conditions. Whether you're looking to automate an existing strategy or develop a completely new 
            approach, we have the expertise to bring your vision to life.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default DetailedSections;